export default __webpack_public_path__ + "static/media/7dc68c40bdaf2b73ce0423a2261700171602178470138.1fbefda2.webp";